module.exports = __webpack_public_path__ + "172d3668319f74a13a29770d7c394b17.svg";